import React from "react";

import { Draggable, Droppable } from "@hello-pangea/dnd";

import { CROP_CREATION_MODAL_TYPE, CROP_TYPE, CropExplorationResponse, CropExplorationTemplateResponse, EntriesByCrops } from "models";

import { CropCreationPopover } from "pages/app/crop-explorer/components/CropCreationPopover";
import { RecommendationCardPopover } from "pages/app/crop-explorer/components/recommendation-card/RecommendationCardPopover.tsx";

export const CropExplorerTimelineColumn = ({
  columnIndex,
  cropExploration,
  entry,
  isAdmin,
  isTourStep,
}: {
  columnIndex: number;
  cropExploration: CropExplorationResponse | CropExplorationTemplateResponse;
  entry: EntriesByCrops;
  isAdmin?: boolean;
  isTourStep?: boolean;
}) => {
  const recommendation = !isAdmin
    ? (cropExploration as CropExplorationResponse).yearlySideCropRecommendations.find((recommendation) => recommendation.year === entry.year)
    : null;

  return (
    <>
      <Droppable key={`${entry.year.toString()}_${CROP_TYPE.MAIN}`} droppableId={`${entry.year.toString()}_${CROP_TYPE.MAIN}`}>
        {(provided, _snapshot) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {entry.main ? (
              <Draggable key={entry.main?.id} draggableId={entry.main?.id ? `${entry.main.id}_${entry.main.cropId}` : ""} index={columnIndex}>
                {(provided, _snapshot) => (
                  <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                    <CropCreationPopover
                      type={CROP_CREATION_MODAL_TYPE.EDIT}
                      crop={entry.main}
                      cropType={CROP_TYPE.MAIN}
                      cropExploration={cropExploration}
                      year={entry.year}
                      isAdmin={isAdmin}
                      cardId={`crop-card${entry.year}-main-${entry.main?.id}`}
                      key={`crop-card${entry.year}-main-${entry.main?.id}`}
                    />
                  </div>
                )}
              </Draggable>
            ) : (
              <CropCreationPopover
                type={CROP_CREATION_MODAL_TYPE.ADD}
                cropType={CROP_TYPE.MAIN}
                cropExploration={cropExploration}
                year={entry.year}
                isAdmin={isAdmin}
                cardId={`crop-card${entry.year}-main-empty`}
                key={`crop-card${entry.year}-main-empty`}
              />
            )}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      <Droppable key={`${entry.year.toString()}_${CROP_TYPE.SIDE}`} droppableId={`${entry.year.toString()}_${CROP_TYPE.SIDE}`}>
        {(provided, _snapshot) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {entry.side.map((sideCrop, i) => (
              <Draggable key={sideCrop.id} draggableId={`${sideCrop.id}_${sideCrop.cropId}`} index={i}>
                {(provided, _snapshot) => (
                  <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className="margin-bottom-100">
                    <CropCreationPopover
                      type={CROP_CREATION_MODAL_TYPE.EDIT}
                      crop={sideCrop}
                      cropType={CROP_TYPE.SIDE}
                      cropExploration={cropExploration}
                      year={entry.year}
                      isAdmin={isAdmin}
                      cardId={`crop-card${entry.year}-side-${sideCrop.id}-${i}`}
                      key={`crop-card${entry.year}-side-${sideCrop.id}-${i}`}
                      isTourStep={i === 0 && isTourStep}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {recommendation && !isAdmin && (
              <RecommendationCardPopover recommendation={recommendation} cropExploration={cropExploration as CropExplorationResponse} />
            )}
            <CropCreationPopover
              type={CROP_CREATION_MODAL_TYPE.ADD}
              cropType={CROP_TYPE.SIDE}
              cropExploration={cropExploration}
              year={entry.year}
              isAdmin={isAdmin}
              cardId={`crop-card${entry.year}-side-empty-${entry.side.length}`}
              key={`crop-card${entry.year}-side-empty-${entry.side.length}`}
              isTourStep={entry.side.length === 0 && isTourStep}
            />
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </>
  );
};
